import { useMemo, useState } from "react";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { CoaMappingEmptyState } from "./CoaMappingEmptyState";
import { filterCoaMappingRows } from "./filterCoaMappingRows";
import { CoaMappingRow } from "./coaMappingRowTypes";
import {
    buildCoaMappingSourceView,
    CoaMappingColumn,
    CoaMappingViewConfig,
} from "./coaMappingViewConfig";
import styles from "./CoaMappingDrawer.module.scss";

interface Props {
    rows: CoaMappingRow[] | null;
    viewConfig: CoaMappingViewConfig;
}

const view = buildCoaMappingSourceView();

// The incoming chart as context beside the editor: the mapping step's tree and
// name cell, read-only, with its own search and expansion.
export const CoaMappingSourceChartPane = ({ rows, viewConfig }: Props) => {
    const [searchFilter, setSearchFilter] = useState<string | undefined>();
    const visibleRows = useMemo(
        () => (rows ? filterCoaMappingRows({ rows, searchFilter }) : null),
        [rows, searchFilter],
    );

    return (
        <div className={styles.pane}>
            <TablePageHeader
                isFullPage
                borderBottom
                search={searchFilter}
                onSearchChange={(value) => setSearchFilter(value || undefined)}
                searchKeyboardShortcuts={false}
            />
            <div className={styles.tableContainer}>
                <ViewTable<CoaMappingRow, CoaMappingColumn, never>
                    data={visibleRows}
                    view={view}
                    config={viewConfig}
                    autoExpandOnMount
                    nestingIndentPx={16}
                    enableColumnResizing={false}
                    emptyView={() => (
                        <CoaMappingEmptyState searchFilter={searchFilter} />
                    )}
                />
            </div>
        </div>
    );
};
